import cacheLs from "../cacheLs"

export default {
  setGpathSession (state, data) {
    state.gpathSession = { ...data }
    cacheLs.set_gpath_session(data)
  }
}
